import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { FaCheckCircle, FaTrashAlt } from "react-icons/fa";
import Navbar from "../../components/Navbar/Navbar";
import Title from "../../components/Title";
import { API } from "../../config/api";
import Pagination from "../../components/Pagination/Pagination";
import { Transition } from "@tailwindui/react";
import DeleteModal from "../../components/Modal/DeleteModal";

function Index(props) {
  const [showDelete, setshowDelete] = useState(false);
  const [page, setpage] = useState(1);
  // Status handle Function
  const statusHandle = (status) => {
    if (status === "Approved") {
      return <p className="text-success">Approve</p>;
    }
    if (status === null) {
      return <p className="text-yellow-600">Waiting to be verifed</p>;
    }
    if (status === "Canceled") {
      return <p className="text-danger">Cancel</p>;
    }
  };

  const [idBook, setidBook] = useState();
  // Use Query Get Books
  const { isLoading, error, data: bookData, refetch } = useQuery(
    "getBookAdmin",
    () => API.get(`/books?page=${page}`)
  );
  // HandlePageClick
  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    console.log(selectedPage + 1);
    setpage(selectedPage + 1);
  };

  useEffect(() => {
    setpage(page);
    refetch();
  }, [page]);
  // Set Approve
  const [setApprove] = useMutation(async () => {
    try {
      await API.patch(`/book/approve/${idBook}`);
      refetch();
    } catch (err) {
      console.log(err);
    }
  });
  // Set Cancel
  const [setCancel] = useMutation(async () => {
    try {
      await API.patch(`/book/cancel/${idBook}`);
      refetch();
    } catch (err) {
      console.log(err);
    }
  });
  const [deleteData] = useMutation(async () => {
    try {
      await API.delete(`/book/${idBook}`);
      refetch();
    } catch (err) {
      console.log(err);
    }
  });
  // Handle Cancel Click
  const handleCancel = (id) => {
    setidBook(id);
    setCancel();
  };
  // Handle Approve Click
  const handleApprove = (id) => {
    setidBook(id);
    setApprove();
  };

  const handleDelete = () => {
    deleteData();
    setshowDelete(false);
  };

  return (
    <div className="w-full">
      <Navbar />
      <div className="bg-gray-100 min-h-screen px-16 py-12">
        <Title name="Book verification" />
        <div>
          <table className="min-w-full divide-y divide-gray-400">
            <thead className="text-left">
              <tr className="bg-white">
                <th className="px-6 py-6">No</th>
                <th className="px-6 py-6">Users or Author</th>
                <th className="px-6 py-6">ISBN</th>
                <th className="px-6 py-6">E-book</th>
                <th className="px-6 py-6">Status</th>
                <th className="px-6 py-6">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-400 text-left">
              {isLoading || !bookData?.data.data ? (
                <tr className="divide-y divide-gray-400 text-center">
                  <td className="px-6 py-6" colSpan="6">
                    <p>Loading....</p>
                  </td>
                </tr>
              ) : error ? (
                error.message
              ) : (
                bookData.data.data.map((book, index) => (
                  <tr key={index} className="divide-y divide-gray-400">
                    <td className="px-6 py-6">{index + 1}</td>
                    <td className="px-6 py-6">{book.user.fullName}</td>
                    <td className="px-6 py-6">{book.ISBN}</td>
                    <td className="px-6 py-6">{book.file}</td>
                    <td className="px-6 py-6">{statusHandle(book.status)}</td>
                    <td className="px-6 py-6">
                      {book.status === "Canceled" || book.status === null ? (
                        <div>
                          <button
                            onClick={() => handleCancel(book.id)}
                            className="bg-danger py-1 text-white rounded-md px-3 mr-4"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={() => handleApprove(book.id)}
                            className="bg-success py-1 text-white rounded-md px-3"
                          >
                            Approve
                          </button>
                        </div>
                      ) : (
                        <div className="flex">
                          <FaCheckCircle className="text-2xl text-success ml-6" />
                          <FaTrashAlt
                            onClick={() => {
                              setidBook(book.id);
                              setshowDelete(true);
                            }}
                            className="text-xl cursor-pointer text-danger ml-6"
                          />
                        </div>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {!bookData?.data ? (
            <></>
          ) : (
            <div className="flex w-full justify-center mt-6">
              <Pagination
                handleChangePage={handlePageClick}
                pageCount={bookData.data.totalPages}
              />
            </div>
          )}
        </div>
      </div>
      <Transition show={showDelete}>
        <DeleteModal
          handleDeleteClick={() => handleDelete()}
          handleShowDelete={() => setshowDelete(false)}
        />
      </Transition>
    </div>
  );
}

export default Index;
